import FormFormato from "./Form/Form";

export default function EditarFormatosPersonal() {
    return (
        <>
            <h3>Editar formato</h3>
            <FormFormato data={JSON.parse(localStorage.getItem("formatPl"))}/>
        </>
    )
}